import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';

export default function Month(props) {
  const {
    month,
  } = props || {};
  return (
    <div {...ex('Month', props)}>
      {month}
    </div>
  );
}
